<template>
  <div class="tekbox-message-display">
    <div class="tekbox-content" :class="'border-' + displayMessage.color">
      <span class="tekbox-heading">
        <span class="fa" :class="displayMessage.icon + ' text-' + displayMessage.color"></span>
        {{ displayMessage.text }}
      </span>
      <p v-if="data.Account">
        <strong class="text-muted small">Message sent by:</strong>
        <router-link :to="'/membership/members/' + data.Account.uuid">
          {{ data.Account.dropdownLabel }}
        </router-link>
      </p>
      <p class="text-muted small my-1"><span class="fa fa-calendar-alt fa-fw"></span> {{ data.createdAt | date_format }}</p>
      <p v-if="data.Car" class="my-2">
        <router-link :to="'/fleet/vehicles/' + data.Car.uuid">
          {{ data.Car.name }} (#{{ data.Car.convadisId }} - {{ data.Car.rego }})
        </router-link>
      </p>
      <p v-if="data.Reservation" class="my-1">
        <router-link :to="'/fleet/reservations/' + data.Reservation.uuid">
          Reservation #{{ data.Reservation.reservationId }}
        </router-link>
      </p>
      <div class="alert alert-info row p-1 small">
        <div class="col-sm-8">
          <span class="fa fa-lg fa-fw" :class="classStatus"></span>
          <span class="small">{{ status }}</span>
        </div>
        <div class="col-sm-4" v-if="location.lat && location.lng">
          <span class="fa fa-fw fa-crosshairs"></span>
          <span class="small">GPS Available</span>
        </div>
        <div class="col-sm-4" v-else>
          <span class="fa fa-fw fa-ban"></span>
          <span class="small">No GPS Available</span>
        </div>
      </div>
      <div class="row" v-if="data.rawMessage.Type === 'returnCapture'">
        <div class="col-sm-12">
          <button class="btn btn-xs btn-default" type="button" @click="assignSmartCard(data.rawMessage.TekboxResponse.ChipPersId)">
            <span class="fa fa-address-card fa-fw"></span> Assign Smart Card ({{ data.rawMessage.TekboxResponse.ChipPersId }})
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <button class="btn btn-xs btn-dark" type="button" @click="$refs.rawMessage.style.display == 'none' ? viewRawMessage() : hideRawMessage()">
            <span class="fa fa-code fa-fw"></span> Show Raw Message
          </button>
        </div>
        <div class="col-sm-4">
          <template v-if="location.lat && location.lng">
            <a target="_blank" class="btn btn-xs btn-info" :href="googleMaps">
              <span class="fa fa-map-marker-alt"></span> View Location
            </a>
          </template>
        </div>
      </div>
      <pre style="display: none; position: relative;" ref="rawMessage" class="well mt-2">{{ data.rawMessage }}<button type="button" class="close position-absolute" style="top: 10px; right: 15px;" aria-label="Close" @click="hideRawMessage()"><span aria-hidden="true">&times;</span></button></pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TekboxMessageDisplay',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    googleMaps () {
      return 'https://maps.google.com/?q=' +
      this.location.lat + ',' + this.location.lng
    },
    status () {
      if (this.data.type.includes('response')) return 'Notification Received'
      return this.data.acknowledged ? 'Acknowledged' : 'Waiting for Acknowledgement'
    },
    classStatus () {
      if (this.data.type.includes('response')) return 'fa-exclamation-circle text-info'
      return this.data.acknowledged ? 'fa-check text-success' : 'fa-rss text-muted'
    },
    location () {
      let loc = { lat: 0, lng: 0 }
      if (this.data.rawMessage.TekboxResponse && this.data.rawMessage.TekboxResponse.GPS) {
        loc.lat = parseFloat(this.data.rawMessage.TekboxResponse.GPS.Latitude)
        loc.lng = parseFloat(this.data.rawMessage.TekboxResponse.GPS.Longitude)
      }
      return loc
    },
    displayMessage () {
      const types = {
        response: {
          geofenceBreach: {
            text: 'Geofence Breach',
            icon: 'fa-compass',
            color: 'danger'
          },
          ignitionOn: {
            text: 'Ignition On',
            icon: 'fa-power-off',
            color: 'primary'
          },
          voltage: {
            text: 'Voltage',
            icon: 'fa-bolt',
            color: 'warning'
          },
          ignitionOff: {
            text: 'Ignition Off',
            icon: 'fa-minus-circle',
            color: 'primary'
          },
          tripData: {
            text: 'Trip Data',
            icon: 'fa-info-circle',
            color: 'success'
          },
          startReservation: {
            text: 'Reservation Started',
            icon: 'fa-play-circle',
            color: 'primary'
          },
          odometer: {
            text: 'Odometer',
            icon: 'fa-tachometer-alt',
            color: 'primary'
          },
          unlockCar: {
            text: 'Unlock Car',
            icon: 'fa-unlock',
            color: 'pink'
          },
          lockCar: {
            text: 'Lock Car',
            icon: 'fa-lock',
            color: 'amber'
          },
          status: {
            text: 'Status',
            icon: 'fa-crosshairs',
            color: 'warning'
          },
          stopcar: {
            text: 'Stop Car',
            icon: 'fa-power-off',
            color: 'warning'
          },
          startCar: {
            text: 'Start Car',
            icon: 'fa-power-off',
            color: 'success'
          },
          gpsStart: {
            text: 'GPS Start',
            icon: 'fa-crosshairs',
            color: 'success'
          },
          gpsStop: {
            text: 'GPS Stop',
            icon: 'fa-crosshairs',
            color: 'warning'
          },
          fuelCardInserted: {
            text: 'Fuel Card Inserted',
            icon: 'fa-download',
            color: 'success'
          },
          invalidFuelCard: {
            text: 'Invalid Fuel Card',
            icon: 'fa-times',
            color: 'danger'
          },
          fuelCardRemoved: {
            text: 'Fuel Card Removed',
            icon: 'fa-upload',
            color: 'danger'
          },
          cardSwiped: {
            text: 'Card Swiped',
            icon: 'fa-sign-in-alt',
            color: 'warning'
          },
          returnCapture: {
            text: 'Captured SmartCard',
            icon: 'fa-address-card',
            color: 'success'
          },
          // remove later
          ignitionOnAlarm: {
            text: 'Ignition On',
            icon: 'fa-power-off',
            color: 'primary'
          },
          ignitionOffAlarm: {
            text: 'Ignition Off',
            icon: 'fa-minus-circle',
            color: 'primary'
          }
        },
        request: {
          newReservation: {
            text: 'New Reservation',
            icon: 'fa-calendar-plus',
            color: 'success'
          },
          modifyReservation: {
            text: 'Modify Reservation',
            icon: 'fa-calendar-alt',
            color: 'purple'
          },
          cancelReservation: {
            text: 'Cancel Reservation',
            icon: 'fa-ban',
            color: 'danger'
          },
          lockDoor: {
            text: 'Lock Door',
            icon: 'fa-lock',
            color: 'amber'
          },
          unlockDoor: {
            text: 'Unlock Door',
            icon: 'fa-unlock',
            color: 'pink'
          },
          unlockCar: {
            text: 'Unlock Car',
            icon: 'fa-unlock',
            color: 'pink'
          },
          lockCar: {
            text: 'Lock Car',
            icon: 'fa-lock',
            color: 'amber'
          },
          startCar: {
            text: 'Turn Ignition On',
            icon: 'fa-power-off',
            color: 'primary'
          },
          stopCar: {
            text: 'Turn Ignition Off',
            icon: 'fa-minus-circle',
            color: 'primary'
          },
          immobolize: {
            text: 'Immobilize',
            icon: 'fa-hand-paper',
            color: 'danger'
          },
          mobilize: {
            text: 'Mobilize',
            icon: 'fa-thumbs-up',
            color: 'success'
          },
          status: {
            text: 'Status',
            icon: 'fa-crosshairs',
            color: 'warning'
          },
          capture: {
            text: 'Capture next Card',
            icon: 'fa-id-card',
            color: 'warning'
          },
          newValet: {
            text: 'New Valet',
            icon: 'fa-user-plus',
            color: 'purple'
          },
          deleteValet: {
            text: 'Delete Valet',
            icon: 'fa-user-times',
            color: 'danger'
          },
          techPush: {
            text: 'Tech Push',
            icon: 'fa-cloud-upload-alt',
            color: 'primary'
          },
          requestTripData: {
            text: 'Request Trip Data',
            icon: 'fa-cloud-download-alt',
            color: 'success'
          }
        }
      }
      let message = types[this.data.type][this.data.rawMessage.Type]
      return message || { text: this.data.rawMessage.Type, icon: 'fa-comment-alt', color: 'primary' }
    }
  },
  methods: {
    viewRawMessage () {
      this.$refs.rawMessage.style.display = 'block'
    },
    hideRawMessage () {
      this.$refs.rawMessage.style.display = 'none'
    },
    assignSmartCard (chipId) {
      this.$router.push('/membership/smartcards/assign-captured/' + chipId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/TekboxMessageDisplay.vue